import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ConfirmationModal from "views/components/ConfirmationModal";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { getDisbursalDatePreviousLoan } from "../Disbursal/SameDayProcessingFee";
import { repledgeCaseListName } from "assets/properties/properties";
import { sanitizeLoanAccountNumber } from "utils/Utils";
import { APPLICATION_SUB_TYPE_POST_PLEDGE } from "assets/properties/properties";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import { parseAndSetFlag } from "utils/Utils";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";

const Disbursal = ({ seletedBranchCode, featureFlags }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag] = useState(false);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [leadBranchCode, setLeadBranchCode] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [noTopUpLoanTypes, setNoTopUpLoanTypes]=useState([])
  const [enabledInsurance, setEnabledInsuranceFlag]= useState(false)
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
    refetch: refetchApplicantData,
  } = useApplicantStatusData({
    status: "DISBURSAL_INITIATED",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  useEffect(() => {
    if (!featureFlags) return;
    parseFlags(featureFlags.showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag);
    parseFlags(featureFlags.enabledInsuranceFlowFlag, setEnabledInsuranceFlag);
    setNoTopUpLoanTypes(featureFlags.noTopUpLoanTypes);
  }, [featureFlags]);
  const parseFlags = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  console.log(enabledSendBackStageDetails,"fksbfksdh")
  const [tableColumns, setTableColumns] = useState([
    { id: "applicationid", label: "Application ID", show: true },
    { id: "created", label: "Created By", show: true },
    { id: "formNumber", label: "Application Number", show: true },
    { id: "accountNumber", label: "Loan Account Number", show: true },
    { id: "linkedBranch", label: "Sourcer Branch Name", show: true },
    { id: "customerid", label: "Customer Id", show: true },
    { id: "customerName", label: "Customer Name", show: true },
    { id: "productType", label: "Product Type", show: true },
    { id: "type", label: "Application Type", show: true },
    ...(enabledSendBackStageDetails
    ? [{ id: "stageHistory", label: "Stage History" , show: true}]
    : []),
    { id: "action", label: "Action", show: true },
    {id: "mobile", label:"Mobile", show: false},
  ]);
  useEffect(() => {
    setTableColumns((prevList) =>
      prevList.map((item) => {
        switch (item.id) {
          case "linkedBranch":
            return { ...item, show: showLinkedLoanBranchFlag };
          default:
            return item;
        }
      })
    );
  }, [showLinkedLoanBranchFlag]);

  const visibleDeliverables = tableColumns.filter((item) => item.show);

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((DisbursalApplication, index) => {
        let row = {
          applicationid: DisbursalApplication.loanApplicationId,
          created: DisbursalApplication.createdBy,
          formNumber: DisbursalApplication.loanApplicationNumber,
          accountNumber: DisbursalApplication.loanAccountNumber,
          linkedBranch: DisbursalApplication.linkedLoanBranchName,
          customerid: DisbursalApplication.customerId,
          customerName: DisbursalApplication.customerName,
          type: `${removeUnderscores(
            DisbursalApplication?.applicationType
          )} / ${removeUnderscores(DisbursalApplication?.applicationSubType)}`,
          totalCollateralValue: DisbursalApplication?.totalCollateralValue,
          initiator: DisbursalApplication?.initiator,
          branchCode: DisbursalApplication?.branchCode?.trim(),
          action: GetAction(
            DisbursalApplication.loanApplicationId,
          ),
          mobile: DisbursalApplication?.mobileNumber,
          productType: DisbursalApplication?.productType,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  DisbursalApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        DisbursalApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
        };
        reportData.push(row);
      });

    setSelectedTableData(reportData);
  };
  const GetAction = (
    loanApplicationId,
  ) => {
    return (
      <>
        <Button
          aria-label="Delete Disbursal"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            showDeleteResponse(loanApplicationId);
          }}
        >
          Reject
        </Button>
      </>
    );
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanApplicationNumber,
    customerProcessId,
    loanAccNumber,
    totalCollateralValue,
    initiator,
    mobile,
    branchCode,
    productType,
  ) => {
     setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
    setLeadBranchCode(branchCode);
    setLoanAPPLICATIONID(loanApplicationId);
   const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
      let prepledgeLoanData = [];
      const checkEligibleData = result?.data?.applicationSubType === repledgeCaseListName?.renew || result?.data?.applicationSubType === repledgeCaseListName?.topUp || result?.data?.applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE
      if (Object.keys(prepledgeLoanMap || {})?.length >= 1 && checkEligibleData) {
        const res = await apiHandler({
          url: endpoint.GET_ALL_DATA_MOBILE_NUMBER,
          authToken: authToken,
          method: "POST",
          data: {
            mobileNumber: mobile,
            source: "WEB",
            renewalFlag:result?.data?.applicationSubType === repledgeCaseListName?.renew ? true : false,
            toupFlag:result?.data?.applicationSubType === repledgeCaseListName?.topUp ? true : false,
            includeBtLoans: result?.data?.applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE, 
          },
        });
        setCallInProgress(false);
        if (!res?.data?.error_code) {
          const loanArray = res?.data || [];
          const loanMap = prepledgeLoanMap || {};

          const finalResult =
            loanMap && Object.keys(loanMap).length
              ? Object.keys(loanMap).flatMap((key) => {
                  const matched = loanArray?.filter(
                    (item) => sanitizeLoanAccountNumber(item?.loanAccountNumber, featureFlags?.convertLoanAccountMunber) === key
                  );
                  return matched.map((item) => ({
                    ...item,
                  }));
                })
              : [];
          console.log(finalResult, prepledgeLoanMap, "ashkdjahksj");
          prepledgeLoanData = finalResult;
        }
      }
    const btLoan = prepledgeLoanData?.find((loan) => loan?.status === "BT");
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber
      ? result?.data?.prepledgeLoanAccountNumber
      : btLoan?.loanAccountNumber || Object.keys(prepledgeLoanMap || {})?.[0];
      console.log(prepledgeLoanAccountNumber,"prepledgeLoanAccountNumber")
    if (
      prepledgeLoanAccountNumber &&
      (
        Object.keys(prepledgeLoanMap || {}).length === 1 ||
        result?.data?.applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE
      )
    ) {
      setCallInProgress(true);
      const result1 = await apiHandler({
        url: `${endpoint.GET_ADJUSTED_LOAN_DATA}${prepledgeLoanAccountNumber}`,
        authToken,
      });
      const dataPrevApplication = await apiHandler({
        url: endpoint.LOAN_STATUS + `?loanAccountNumber=${prepledgeLoanAccountNumber}`,
        authToken,
      });
    
      setCallInProgress(false);
    
      await modalDecision(
        loanApplicationId,
        loanApplicationNumber,
        customerProcessId,
        loanAccNumber,
        totalCollateralValue,
        initiator,
        mobile,
        branchCode,
        result?.data,
        result1?.data?.disbursalDetails?.[0]?.disbursalDate,
        dataPrevApplication?.data,
        prepledgeLoanData,
        productType
      );
    } else {
      await modalDecision(
        loanApplicationId,
        loanApplicationNumber,
        customerProcessId,
        loanAccNumber,
        totalCollateralValue,
        initiator,
        mobile,
        branchCode,
        result?.data,
        "",
        "",
        prepledgeLoanData,
        productType
      );
    }
  };
const modalDecision = async (loanApplicationId, loanApplicationNumber, customerProcessId, loanAccNumber, totalCollateralValue, initiator,mobile ,branchCode, data, date, prevData, prepledgeLoanData, productType) => {
   const insuranceResult = await apiHandler({
          url: endpoint.CHECK_FOR_INSURANCE + loanApplicationId,
          method: "GET",
          authToken: authToken,
        });
         const prepledgeLoanMap = data?.prepledgeLoanMap || [];
      const prepledgeLoanAccountNumber = data?.prepledgeLoanAccountNumber ? data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]  
    const noTopLoans=  typeof noTopUpLoanTypes !== "undefined" ? JSON.parse(noTopUpLoanTypes) : [];
    const loanIncluded = noTopLoans?.includes(data?.applicationSubType) 
    const insuranceFLag = typeof insuranceResult?.data?.data?.INSURANCE_APPLICABLE !== 'undefined' && !loanIncluded && enabledInsurance && insuranceResult?.data?.data?.INSURANCE_APPLICABLE === true ? true : false;
    const amountActual = await getDisbursalDatePreviousLoan(data?.applicationSubType, featureFlags, prepledgeLoanAccountNumber, authToken, loanApplicationId, setCallInProgress, prevData?.applicationSubType, prepledgeLoanMap)
    const navigationData = {
      loanApplicationId,
      loanApplicationNumber,
      status: "DISBURSAL",
      subStatus: data?.applicationSubType || "",
      prePledgeLoan:prepledgeLoanAccountNumber|| "",
      editable: false,
      loanType: data?.applicationType || "",
      initiatorType: initiator,
      leadBranchCode: branchCode,
      totalCollateralValue,
      seletedBranchCode,
      customerProceedId: customerProcessId,
      loanAccountNumber: loanAccNumber,
      prePledgeDisbursalDate: date,
      loanApplicationNumbedisbusalDetails: loanApplicationNumber,
      enabledInsurance: insuranceFLag,
      actualLoanAmount: amountActual,
      prepledgeLoanMap:prepledgeLoanMap,
      prepledgeLoanData:prepledgeLoanData,
      productType:productType,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
  const onClickDeleteData = async (id) => {
    const result = await apiHandler({
      url: endpoint.SANCTION_STATUS_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        loanApplicationId: id,
        status: "REJECTED",
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", "Error in REJECT of Disbursal", true);
    } else {
      UnAssignPacketNumber(id);
    }
  };

  const showDeleteResponse = (loanApplicationId) => {
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg("Are you sure you want to Reject this entry");
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickDeleteData(loanAPPLICATIONID);
  };

  const UnAssignPacketNumber = async (loanApplicationId) => {
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    if (res?.data) {
      toastUpdate("Success", "Loan application rejected successfully", true);
      refetchApplicantData();
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label=" Disbursal Details"
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={visibleDeliverables}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="disbursal"
        />
      </Grid>
       <StageHistoryModal
      open={stageHistoryModal}
      onClose={() => {
        setStageHistoryModal(false);
        setSelectedLeadId(null);
      }}
      leadId={selectedLeadId}
      authToken={authToken}
    />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {(callInProgress || applicantDataLoading) && <CircularProgresss callInProgress />}
    </Grid>
  );
};

Disbursal.propTypes = {
  classes: PropTypes.object,
};

export default Disbursal;
